import ApiService from '@/api/service/ApiService.js';
const uuidv1 = require('uuid/v1');

var ReportLogService = {
    getDownloadLink:function($id){
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="getDownloadLink/"+$id
            $options.method="get"
            //$options.responseType= 'blob', // important
           // $options.responseType = 'arraybuffer'
            //responseType: 'arraybuffer'

            ApiService.request($options)
                .then(response => {
                    console.log(response.headers)
                   // console.log('Gpt the data');
                   resolve(response)
                    //resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    download: function($id) {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="reportLog/download/"+$id
            $options.method="get"
            //$options.responseType= 'blob', // important
           // $options.responseType = 'arraybuffer'
            //responseType: 'arraybuffer'

            ApiService.request($options)
                .then(response => {
                    console.log(response.headers)
                   // console.log('Gpt the data');
                   resolve(response)
                    //resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    findAll: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="reportLog"
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                   resolve(reportLogService.formatData(response))
                    //resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    submitReport: function($id)
    {
       return new Promise(function(resolve,reject) {
           var $options= {};
           $options.url ="reportLog/process/"+$id
           console.log($options.url)
           $options.method="get"
          
           ApiService.request($options)
               .then(response => {
                   console.log('Gpt the data');
                  resolve(response)
                   //resolve(response.data.data)
               }).catch(error=> {
                   console.log('got an error')
                   reject(error);
               })
       });

   },
    findOne: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="reportLog/"+$data.id
            console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    save: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
            $options.data.company_code =$data.company_code
            $options.data.name= $data.name;
            $options.data.address1 = $data.address1
            $options.data.address2 = $data.address2
            $options.data.city = $data.city
            $options.data.country_id = $data.country_id
            $options.data.state_id = $data.state_id
            $options.data.zip = $data.zip
            $options.data.auth_type = $data.auth_type
            $options.data.active = $data.active
            $options.data.db_info = $data.db_info
            $options.data.description = $data.description
            $options.url = "reportLog/"+$data.id;
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    
    create: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
           // $data.company_id=JSON.parse(localStorage.getItem('tiburaClinic')).data.User.company_id
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
            $options.data.company_code =$data.company_code
            $options.data.name= $data.name;
            $options.data.address1 = $data.address1
            $options.data.address2 = $data.address2
            $options.data.city = $data.city
            $options.data.country_id = $data.country_id
            $options.data.state_id = $data.state_id
            $options.data.zip = $data.zip
            $options.data.auth_type = $data.auth_type
            $options.data.active = $data.active
            $options.data.db_info = $data.db_info
            $options.data.description = $data.description
            $options.url = "reportLog";
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    getStatus:function($data)  {
        console.log($data)
        var $i=0;
        var $query ={ "id":[]}
        return new Promise(function(resolve,reject) {
            //resolve({"1":{"status":0}});
            for($i=0;$i<$data.length;$i++)
            {
                $query.id.push($data[$i].id)
            }
            var $options= {};
            $options.url ="reportLogStatus/?requestId="+JSON.stringify($query)
            //console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                   resolve(response)
                    //resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    validate: function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            $options.url ='reportLog/validate'
            $options.data = $data;
            ApiService.request($options) 
                .then(response => {

                }).catch(error => {

                });
            });

    },
    formatData: function($data) 
    {
        var $i =0;
        var $subscriptions = $data.data.data;
        var $subscriptionList = []; 
        console.log('do you see any data')
        console.log($data)
        var $length = $subscriptions.length; 
        for($i=0;$i<$length;$i++) {
            var $options = {};
            $options.id = $subscriptions[$i].id;
            $options.name = $subscriptions[$i].name
            $options.company = $subscriptions[$i].companyName;
            $options.reports = $subscriptions[$i].reports;
            $options.companies = $subscriptions[$i].companies;
            $options.processing  = $subscriptions[$i].processing;
            $options.report_log_id = $subscriptions[$i].report_log_id
            $options.schedule_at = JSON.parse($subscriptions[$i].schedule_at)
            $options.export_options= JSON.parse($subscriptions[$i].export_options)
            $options.email_to = JSON.parse($subscriptions[$i].email_to)
            $options.modified =$subscriptions[$i].modified
            $subscriptionList.push($options)
            console.log('record finsihed');

        }
        console.log('returned data')
        return $subscriptionList;
    }
};
export default ReportLogService;